import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({  breakpoints,variables, palette }) => ({
  testimonialContent: {
    width: '685px',
    '& .slick-slide img': {
      marginLeft:variables?.spacingB,
      width:'95px',
      height:'162px',
      borderRadius:variables?.radiusRoundedE,
      objectFit:'cover',
      [breakpoints.down('xs')]:{ 
        width:'87vw',
        height:'162px',
        borderRadius:variables?.radiusRoundedD,
        objectFit:'cover',
        marginLeft:'-2px'
      }
    },
    [breakpoints.down('xs')]:{
      width:'98vw',
      overflow:'hidden',
      minHeight: '385px',
    },
    '& .slick-dots':{
      [breakpoints.down('xs')]:{
        textAlign:'left',
        paddingLeft:variables?.spacingD
      }
    },
    margin: '0 auto',
    '& .testimonial-item': {
      '& .testimonial-container': {
        display: 'flex',
        [breakpoints.down('xs')]: {
          flexDirection:'column',
        },
        '& .testimonial-image':{
          [breakpoints.down('xs')]:{
           marginLeft:variables?.spacingE
          }
       },
        '& .testimonial-content': {
          paddingLeft: variables?.spacingE,
          paddingTop: variables?.spacingB,
          '& .testimonial-comment': {
            marginBottom: variables?.spacingD,
            [breakpoints.down('xs')]:{
              width:'90vw'
            }
          },
          '& .testimonial-name': {
            marginBottom: variables?.spacingD,
            [breakpoints.down('xs')]:{
              marginBottom: variables?.spacingG,
            }
          },
          '& .testimonial-star-holder': {
           color:palette?.jet?.contentBrand,
           [breakpoints.down('xs')]:{
              marginBottom:variables?.spacingB
            }
          },
        },
      },
    },
  },
}));

export default useStyles;
